"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AngleBorrowHelpers__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "contract IVaultManager",
                name: "vaultManager",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "getControlledVaults",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class AngleBorrowHelpers__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AngleBorrowHelpers__factory = AngleBorrowHelpers__factory;
AngleBorrowHelpers__factory.abi = _abi;
//# sourceMappingURL=AngleBorrowHelpers__factory.js.map